namespace GeniuzPOS.QRreport {
    export interface QRywcSpec_icrp04Form {
        ReportId: Serenity.LookupEditor;
        ReportName: Serenity.StringEditor;
        UrlReport: Serenity.StringEditor;
        DataStructureName: Serenity.StringEditor;
        LineNo: Serenity.IntegerEditor;
        GruopType: Serenity.RadioButtonEditor;
    }

    export class QRywcSpec_icrp04Form extends Serenity.PrefixedContext {
        static formKey = 'QRreport.QRywcSpec_icrp04';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!QRywcSpec_icrp04Form.init)  {
                QRywcSpec_icrp04Form.init = true;

                var s = Serenity;
                var w0 = s.LookupEditor;
                var w1 = s.StringEditor;
                var w2 = s.IntegerEditor;
                var w3 = s.RadioButtonEditor;

                Q.initFormType(QRywcSpec_icrp04Form, [
                    'ReportId', w0,
                    'ReportName', w1,
                    'UrlReport', w1,
                    'DataStructureName', w1,
                    'LineNo', w2,
                    'GruopType', w3
                ]);
            }
        }
    }
}
